"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADING_SIZES = void 0;
var HEADING_SIZES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
exports.HEADING_SIZES = HEADING_SIZES;